import React, { useEffect } from 'react';
import { TrendingUp, Target, Award, Calendar } from 'lucide-react';
import { trackDashboard, trackPageView } from '@/services/analytics';
import { useScrollTracking } from '@/hooks/useAnalytics';

const DashboardLearning: React.FC = () => {
  useScrollTracking('DashboardLearning');

  useEffect(() => {
    trackDashboard.view('learning');
    trackPageView('DashboardLearning');
  }, []);

  return (
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-white mb-2 flex items-center gap-3">
          <TrendingUp className="w-10 h-10" />
          Continuous Learning
        </h1>
        <p className="text-gray-300 text-lg">
          Track your progress and set learning goals
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-slate-800/60 backdrop-blur-sm border-2 border-indigo-500/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-gray-400 text-sm font-medium">Learning Streak</h3>
            <Target className="w-5 h-5 text-indigo-400" />
          </div>
          <p className="text-3xl font-bold text-white">0 days</p>
          <p className="text-xs text-gray-500 mt-1">Keep learning to build your streak</p>
        </div>

        <div className="bg-slate-800/60 backdrop-blur-sm border-2 border-purple-500/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-gray-400 text-sm font-medium">Certificates Earned</h3>
            <Award className="w-5 h-5 text-purple-400" />
          </div>
          <p className="text-3xl font-bold text-white">0</p>
          <p className="text-xs text-gray-500 mt-1">Complete courses to earn certificates</p>
        </div>

        <div className="bg-slate-800/60 backdrop-blur-sm border-2 border-blue-500/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-gray-400 text-sm font-medium">Hours Learned</h3>
            <Calendar className="w-5 h-5 text-blue-400" />
          </div>
          <p className="text-3xl font-bold text-white">0 hrs</p>
          <p className="text-xs text-gray-500 mt-1">Time spent learning this month</p>
        </div>
      </div>

      {/* Learning Goals Section */}
      <div className="bg-slate-800/60 backdrop-blur-sm border-2 border-indigo-500/30 rounded-2xl p-8">
        <h2 className="text-2xl font-bold text-white mb-6">Your Learning Goals</h2>
        
        <div className="text-center py-12">
          <Target className="w-16 h-16 mx-auto mb-4 text-gray-500" />
          <h3 className="text-xl font-semibold text-gray-300 mb-2">No Goals Set Yet</h3>
          <p className="text-gray-400 mb-6">
            Set learning goals to stay motivated and track your progress
          </p>
          <button className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:shadow-lg hover:shadow-indigo-500/50 transition-all">
            Set Your First Goal
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardLearning;
